import { z } from 'zod';
import { isValidPhoneNumber } from 'react-phone-number-input';
import dayjs from 'dayjs';

import {
  AttendeesArenaRequiredErrorText,
  CaptchaRequiredText,
  CompanyErrorText,
  EmailErrorText,
  EmailValidErrorText,
  EventEndDateError,
  EventErrorText,
  EventStartDateError,
  FirstNameErrorText,
  LastNameErrorText,
  PhoneErrorText,
  PhoneRequiredErrorText,
  TermsErrorText,
} from '@/lib/react-intl/TranslatedTexts';

// BEFORE-BUILD: captcha 주석 제거하기

export const zodEventType = z.object({
  business_key: z.string().nullable(),
  event_type_key: z.string().nullable(),
});

export const zodEvent = z.object({
  first_name: z.string().min(1, { message: <FirstNameErrorText /> }),
  last_name: z.string().min(1, { message: <LastNameErrorText /> }),
  email: z
    .string()
    .min(1, { message: <EmailErrorText /> })
    .email({ message: <EmailValidErrorText /> }),
  phone: z
    .string()
    .min(1, { message: <PhoneRequiredErrorText /> })
    .refine(
      (value) => {
        return isValidPhoneNumber(value);
      },
      {
        message: <PhoneErrorText />,
      }
    ),
  company_name: z.string().min(1, { message: <CompanyErrorText /> }),
  event_name: z.string().min(1, { message: <EventErrorText /> }),
  arrival_date: z.custom((val) => val === '' || dayjs.isDayjs(val)).nullable(),
  departure_date: z.custom((val) => val === '' || dayjs.isDayjs(val)).nullable(),
  attendees: z.string().nullable(),
  rooms: z.string().nullable(),
  comments: z.string().nullable(),
  term: z.boolean().refine((value) => value === true, {
    message: <TermsErrorText />,
  }),
  captcha: z.boolean().refine((value) => value === true, {
    message: <CaptchaRequiredText />,
  }),
});

export const zodArena = z.object({
  event_type: z.string().nullable(),
  first_name: z.string().min(1, { message: <FirstNameErrorText /> }),
  last_name: z.string().min(1, { message: <LastNameErrorText /> }),
  email: z
    .string()
    .min(1, { message: <EmailErrorText /> })
    .email({ message: <EmailValidErrorText /> }),
  phone: z
    .string()
    .min(1, { message: <PhoneRequiredErrorText /> })
    .refine(
      (value) => {
        return isValidPhoneNumber(value);
      },
      {
        message: <PhoneErrorText />,
      }
    ),
  company_name: z.string().min(1, { message: <CompanyErrorText /> }),
  event_name: z.string().min(1, { message: <EventErrorText /> }),
  attendees: z.string().min(1, { message: <AttendeesArenaRequiredErrorText /> }),

  event_start_date: z.custom((val) => dayjs.isDayjs(val), {
    message: <EventStartDateError />,
  }),
  event_end_date: z.custom((val) => dayjs.isDayjs(val), {
    message: <EventEndDateError />,
  }),
  preparation_start_date: z.custom((val) => val === '' || dayjs.isDayjs(val)).nullable(),
  preparation_end_date: z.custom((val) => val === '' || dayjs.isDayjs(val)).nullable(),
  dismantle_start_date: z.custom((val) => val === '' || dayjs.isDayjs(val)).nullable(),
  dismantle_end_date: z.custom((val) => val === '' || dayjs.isDayjs(val)).nullable(),
  stage_type: z.string().nullable(),
  retractable_chair_yn: z.string().min(1),
  comments: z.string().nullable(),
  term: z.boolean().refine((value) => value === true, {
    message: <TermsErrorText />,
  }),
  captcha: z.boolean().refine((value) => value === true, {
    message: <CaptchaRequiredText />,
  }),
});
